import React from "react";


import { Radio, RadioGroup } from "@headlessui/react";
import { CheckIcon } from '@heroicons/react/20/solid';
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { TwContainer, TwDialog, TwMainLayout } from "../../components/tailwind";
import { useLocalStorage } from "../../hooks";
import { useToast } from "../../provider/ToastProvider";
import { clearLoadingData, loadingState, setActionLoading, setGlobalLoading } from "../../redux/reducers/loadingReducer";
import { userState } from "../../redux/reducers/userReducer";
import { getUrlForBookings, getUrlForUsers } from "../../utils/confighelpers";
import { OnBordingBaseLayout } from "../../components/onboarding/OnBordingBaseLayout";
import * as userActions from "../../redux/reducers/userReducer";
import { classNames } from "../../helpers";
import BZLogo from "../../components/BZLogo";
import TwDrawer from "../../components/tailwind/TwDrawer";
import loader from "../../assets/loader.svg";
import progressdone from "../../assets/progressdone.svg";
import axiosInstance from "../../utils/axiosInstance";
import FitClubProLogoText from "../../components/FitClubProLogoText";

const pricingType = [
  { value: 'month', label: 'Monthly' },
  { value: 'year', label: 'Annually' },
]


export default function BusinessProfileUpSubscriptionUpgrade({ navigation }) {

  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog, closeNotificationDialog } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const [userToken] = useLocalStorage("userToken");
  const userReduxState = useSelector(userState);
  const [loading, setLoading] = React.useState(false);
  const [subscriptionSubmited, setSubscriptionSubmited] = React.useState({});
  const [subscriptionPlan, setSubscriptionPlan] = React.useState([]);
  const [frequency, setFrequency] = React.useState(pricingType[0])
  const [availableUserAccess, setAvailableUserAccess] = React.useState({})
  const [dataSaveProgress, setDataSaveProgress] = React.useState({
    open: false,
    addevent: false,
    subscribEvent: false,
    createAccount: true,
    createSettingUp: false,
  });

  const stripePricingTableId = {
    prod: {
      class: "prctbl_1PkNfRDx1lYwRllZPc6xn0SW", // stripe live account
      event: "prctbl_1PkNfRDx1lYwRllZPc6xn0SW", // stripe live account
      // service: "prctbl_1Pav5kDx1lYwRllZNELAunkE", // stripe live account // stripe test account [Bookzy Services solo]
      service: "prctbl_1QGzYwDx1lYwRllZ4oxUUC2E", // stripe live account // stripe test account [Bookzy Services solo & Plus]
    },
    dev: {
      class: "prctbl_1Pvvk0Dx1lYwRllZkfX9HKe9", // stripe test account
      event: "prctbl_1Pvvk0Dx1lYwRllZkfX9HKe9", // stripe test account
      // service: "prctbl_1Q28tvDx1lYwRllZBXIBxpG5", // stripe test account [Bookzy Services solo]
      service: "prctbl_1QE057Dx1lYwRllZZ1tupnOv", // stripe test account [Bookzy Services solo & Plus]
    }
  };


  const getSubscriptionPlan = async () => {
    setFrequency(pricingType[0])
    dispatch(setGlobalLoading(userReduxState.businessType !== "event"));
    if (location.state?.origin && location.state?.origin == "upgradeSubscription") {
      dispatch(setGlobalLoading(true));
    }
    // setSubscriptionPlan([])
    const requestConfig = {
      method: "get",
      url: `${getUrlForUsers()}getSubscriptionPlans?listFor=${userReduxState.businessType}`,
    };
    const response = await axiosInstance(requestConfig);
    if (response.status === 200) {
      if (response.data.statusCode === 403) {
      } else if (response.data.statusCode === 200) {
        if (response.data.data) {
          setSubscriptionPlan(response.data.data)

          // if (((location?.state && !location.state.hasOwnProperty("origin")) || location.state?.origin !== "paymentprofile") && userReduxState.businessType === "event") {
          // if ((location?.state && location.state.hasOwnProperty("from") && location.state?.from === "onbording") && userReduxState.businessType === "event") {
          //   await Promise.all(response.data.data.map(async (d) => {
          //     if (d.typeOfSubscription === "free") {
          //       await updateUserSubscription(d._id, d);
          //     }
          //     return d;
          //   }));
          // }
        }
      }
    }
    dispatch(setGlobalLoading(false));
  };

  const createUserSubscriptionCheckoutSessions = async (sid, subscriptionDetail) => {
    dispatch(setGlobalLoading(true));
    if (subscriptionDetail.subscriptionFor) {
      const requestConfig = {
        method: "post",
        url: `${getUrlForBookings()}payments/createStripeSubscriptionCheckoutSessions`,
        data: {
          bookzySubscriptionId: sid,
          // businessId: userReduxState.userData?._id,
          success_url: `${window.location.origin}/businessprofilesetup/subscription/success`,
          cancel_url: `${window.location.origin}/businessprofilesetup/subscription/cancel`,
        },
      };

      const response = await axiosInstance(requestConfig);
      if (response.status === 200) {
        if (response.data.statusCode === 403) {
        } else if (response.data.statusCode === 200) {
          let responseData = response.data.data;
          if (responseData.url) {
            window.location.href = responseData.url;
          } else {

          }
        }
      }
    } else {
      /**
       * Old logic for event to update local subscription 
       */
      const requestConfig = {
        method: "post",
        url: `${getUrlForUsers()}updateUserSubscription?`,
        data: {
          subscriptionId: sid,
          businessId: userReduxState.userData?._id
        },
      };

      const response = await axiosInstance(requestConfig);
      if (response.status === 200) {
        if (response.data.statusCode === 403) {
        } else if (response.data.statusCode === 200) {
          if (userReduxState.businessType === "event") {
            window.location.href = "/businessprofilesetup/subscription/success";
          }
        }
      }
    }
    dispatch(setGlobalLoading(false));
  };

  const createUserSubscription = async (sid) => {

    // dispatch(setGlobalLoading(true));
    const requestConfig = {
      method: "post",
      url: `${getUrlForBookings()}payments/createStripeUserSubscription`,
      headers: {
        "x-access-token": userToken,
      },
      data: {
        bookzySubscriptionId: sid,
      },
    };

    const response = await axiosInstance(requestConfig);
    if (response.status === 200) {
      if (response.data.statusCode === 403) {
      } else if (response.data.statusCode === 200) {
        // let responseData = response.data.data;
        setDataSaveProgress((prevValues) => ({
          ...prevValues,
          createSettingUp: true,
          open: false,
        }));
        addNotificationDialog({
          dialogType: "success",
          dialogTitle: "Congratulations!",
          dialogMessage: "Your account is successfully set-up",
          dialogBackdropClick: async () => {
            // window.location.href = "/businessprofilesetup/subscription/success";
            window.location.href = "/home/dashboard";
          },
          dialogBtnClick: async () => {
            window.location.href = "/home/dashboard";
          }
        })
      }
    }
    // dispatch(setGlobalLoading(false));
  };

  const updateUserSubscription = async (sid, subscriptionDetail) => {
    if (subscriptionDetail.subscriptionFor) {
      const requestConfig = {
        method: "post",
        url: `${getUrlForBookings()}payments/updateStripeSubscription`,
        data: {
          bookzySubscriptionId: sid,
          moduleName: userReduxState.businessType,
          // businessId: userReduxState.userData?._id,
        },
      };

      dispatch(setActionLoading(true));
      const response = await axiosInstance(requestConfig);
      dispatch(setActionLoading(false));
      if (response.status === 200) {
        if (response.data.statusCode === 403) {
        } else if (response.data.statusCode === 200) {
          let responseData = response.data.data;
          // setFrequency({})
          // setSubscriptionPlan([...subscriptionPlan])
          // await getAvailableUserAccess()

          dispatch(setActionLoading(true));
          let timer = setInterval(async () => {
            setSubscriptionPlan([])
            await getAvailableUserAccess(async (data) => {
              let primarySubscription = data?.subscriptionDetails?.primarySubscription
              if (primarySubscription
                && subscriptionDetail?.stripeSubscriptionDetails
                && primarySubscription.stripeSubscriptionPlanId === subscriptionDetail.stripeSubscriptionDetails?.stripeSubscriptionPriceId
              ) {
                await getSubscriptionPlan();
                dispatch(setActionLoading(false));
                closeNotificationDialog()
                clearInterval(timer);
                addNotificationDialog({
                  dialogType: "success",
                  dialogTitle: "Success",
                  dialogMessage: "Your subscription is upgrade successfully",
                  dialogBackdropClick: async () => {
                    // navigate("/my-account/billing", { replace: true });
                    window.location.href = "/my-account/billing";
                  },
                  dialogBtnClick: async () => {
                    window.location.href = "/my-account/billing";
                  }
                })
              }
            })
            // await getSubscriptionPlan();
          }, 2000);

          // // old data
          // setSubscriptionPlan([])
          // addNotificationDialog({
          //   dialogType: "success",
          //   dialogTitle: "Success",
          //   dialogMessage: "Your subscription is upgrade successfully",
          //   dialogBackdropClick: async () => {
          //     // navigate("/my-account/billing", { replace: true });
          //     window.location.href = "/my-account/billing";
          //   },
          //   dialogBtnClick: async () => {
          //     // navigate("/my-account/billing", { replace: true });
          //     // window.location.href = "/my-account/billing";
          //     // return;

          //     dispatch(setActionLoading(true));
          //     let timer = setInterval(async () => {
          //       setSubscriptionPlan([])
          //       await getAvailableUserAccess(async (data) => {
          //         let primarySubscription = data?.subscriptionDetails?.primarySubscription
          //         console.log("primarySubscription.stripeSubscriptionPlanId ",
          //           primarySubscription.stripeSubscriptionPlanId
          //         );
          //         console.log("subscriptionDetail", subscriptionDetail);
          //         console.log("subscriptionDetail.stripeSubscriptionDetails?.stripeSubscriptionPriceId",
          //           subscriptionDetail.stripeSubscriptionDetails?.stripeSubscriptionPriceId
          //         );
          //         console.log("primarySubscription.stripeSubscriptionPlanId === subscriptionDetail.stripeSubscriptionDetails?.stripeSubscriptionPriceId",
          //           primarySubscription.stripeSubscriptionPlanId === subscriptionDetail.stripeSubscriptionDetails?.stripeSubscriptionPriceId
          //         );
          //         if (primarySubscription
          //           && subscriptionDetail?.stripeSubscriptionDetails
          //           && primarySubscription.stripeSubscriptionPlanId === subscriptionDetail.stripeSubscriptionDetails?.stripeSubscriptionPriceId
          //         ) {
          //           navigate("/my-account/billing");

          //           await getSubscriptionPlan();
          //           dispatch(setActionLoading(false));
          //           closeNotificationDialog()
          //           clearInterval(timer);
          //         }
          //       })
          //       // await getSubscriptionPlan();
          //     }, 2000);
          //   }
          // })
          // // window.location.href = "/my-account/billing";
          // // window.location.reload();
        }
      }
    } else if ((location?.state && location.state.hasOwnProperty("from") && location.state?.from === "onbording") && userReduxState.businessType === "event") {
      /**
       * Old logic for event to update local subscription 
       */
      return;
      const requestConfig = {
        method: "post",
        url: `${getUrlForUsers()}updateUserSubscription?`,
        data: {
          subscriptionId: sid,
          businessId: userReduxState.userData?._id
        },
      };
      console.log("requestConfig", requestConfig);

      const response = await axiosInstance(requestConfig);
      if (response.status === 200) {
        if (response.data.statusCode === 403) {
        } else if (response.data.statusCode === 200) {
          if (userReduxState.businessType === "event") {
            window.location.href = "/businessprofilesetup/subscription/success";
          }
          if (typeof navigation == "function") {
            // navigation("/businessprofilesetup/done");
          }
        }
      }
    }
    // setTimeout(() => {
    //   dispatch(setActionLoading(false));
    // }, 5000);
  };

  const renderLayout = (layoutType = "full", children) => {
    return layoutType === "full" || layoutType === "onbording" ? (
      <TwMainLayout fullScreen={true} >
        <OnBordingBaseLayout
          // title={"Choose the right plan for you"}
          title={dataSaveProgress.open == false && <FitClubProLogoText className={""} />}
          logoutCallBack={() => { }}
        >
          {children}
          {/* {((location?.state && location.state.hasOwnProperty("origin") && location.state?.origin === "paymentprofile") || userReduxState.businessType !== "default") && children} */}
        </OnBordingBaseLayout>
      </TwMainLayout>
    ) : (layoutType === "upgradeSubscription" ? (
      <TwMainLayout
        headTitle={"My Subscription"}
        children={<>
          {((location?.state && location.state.hasOwnProperty("origin") && location.state?.origin === "paymentprofile") || userReduxState.businessType !== "default") && (<div className="">
            {children}
          </div>)}
        </>} />
    ) : (children));
  }

  const getAvailableUserAccess = async (callback = () => { }) => {
    if (userReduxState.businessType) {

      const userrequest = await axiosInstance({
        method: "get",
        // url: `${getUrlForStage()}schools/mySchoolList`,
        url: `${getUrlForUsers()}getUserInfo`,
      });
      if (userrequest.data.statusCode === 200) {
        dispatch(userActions.setUserData({
          // ...userReduxState.userData,
          appUrl: userReduxState.userData.appUrl,
          ...userrequest.data.data,
        }));
      }

      const config = {
        method: "get",
        url: `${getUrlForUsers()}getAvailableUserAccess/${userReduxState.businessType}`,
      };
      const request = await axiosInstance(config);

      console.log("request.data", request.data);
      if (request.data.statusCode === 200) {
        console.log("data", request.data.data);
        const responseDetails = request.data.data;
        setAvailableUserAccess(responseDetails)
        callback(responseDetails)
        if (responseDetails.subscriptionDetails.primarySubscription.allowbusinessAccess === false) {
          // setOpenSubscriptionWarningDialog(responseDetails.subscriptionDetails.primarySubscription.allowbusinessAccess)
        }
        if (userReduxState.businessType == "event") {
          setDataSaveProgress((prevValues) => ({
            ...prevValues,
            addevent: false,
            subscribEvent: false,
            createSettingUp: true,
            open: false,
          }));
          addNotificationDialog({
            dialogType: "success",
            dialogTitle: "Congratulations!",
            dialogMessage: "Your account is successfully set-up",
            dialogBackdropClick: async () => {
              // window.location.href = "/businessprofilesetup/subscription/success";
              window.location.href = "/home/dashboard";
            },
            dialogBtnClick: async () => {
              window.location.href = "/home/dashboard";
            }
          })
        }
      } else {

        if (userReduxState.businessType == "event") {
          setDataSaveProgress((prevValues) => ({
            ...prevValues,
            open: true,
            addevent: true,
            subscribEvent: false,
          }));
        }
      }
    }
  }

  const subscriptionText = (d, i) => {
    //  : "Start Free "
    let btnText = userReduxState.businessType === "event" ? "Start Free" : "Start Your 30 days Trial";
    let primarySubscription = availableUserAccess?.subscriptionDetails?.primarySubscription
    if (primarySubscription?.allowbusinessAccess && primarySubscription.allowbusinessAccess === true
      && d?.stripeSubscriptionDetails?.stripeSubscriptionPriceId
      && primarySubscription.stripeSubscriptionPlanId
    ) {
      btnText = "Upgrade subscription"
      if (d?.stripeSubscriptionDetails?.stripeSubscriptionPriceId == primarySubscription.stripeSubscriptionPlanId) {
        btnText = "Current subscription"
      }
    }

    if (
      loadingReduxState?.actionLoading && loadingReduxState.actionLoading === true
      && subscriptionSubmited._id
      && d?.stripeSubscriptionDetails?.stripeSubscriptionPriceId === subscriptionSubmited.stripeSubscriptionDetails?.stripeSubscriptionPriceId
    ) {
      btnText = (<div className="flex justify-center items-center gap-2">
        <svg className="text-gray-300 animate-spin" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"
          width="24" height="24">
          <path
            d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
            stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"></path>
          <path
            d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
            stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" className="text-brown-coffee">
          </path>
        </svg>Processing...
      </div>)
    }
    return btnText
  }
  const allowSubscriptionText = (d) => {
    //  : "Start Free "
    let btnText = true;
    let primarySubscription = availableUserAccess?.subscriptionDetails?.primarySubscription
    if (primarySubscription.allowbusinessAccess === true
      && d?.stripeSubscriptionDetails?.stripeSubscriptionPriceId
      && primarySubscription.stripeSubscriptionPlanId
    ) {
      btnText = true
      if (d?.stripeSubscriptionDetails?.stripeSubscriptionPriceId == primarySubscription.stripeSubscriptionPlanId) {
        btnText = false
      }
    }
    return btnText
  }
  const startEventAutomation = async (d) => {
    // console.log("allow Automation", dataSaveProgress.addevent === true && dataSaveProgress.subscribEvent === false && subscriptionPlan.length > 0);
    if (userReduxState.businessType == "event") {
      if (dataSaveProgress.addevent === true && dataSaveProgress.subscribEvent === false && subscriptionPlan.length > 0) {
        let eventSubscription = subscriptionPlan.find((d) => d?.subscriptionFor == "event" && d?.stripeSubscriptionDetails?.stripeSubscriptionPriceId && d?.stripeSubscriptionDetails?.stripeSubscriptionPriceId !== "")

        if (eventSubscription) {
          setDataSaveProgress((prevValues) => ({
            ...prevValues,
            subscribEvent: true,
          }));
          await createUserSubscription(eventSubscription._id)
        }
      } else {
        setTimeout(() => {
          startEventAutomation()
        }, 1000);
      }
    }
  }

  React.useEffect(() => {
    if (userReduxState.businessType !== "") {
      if (userReduxState.businessType == "event") {
        setDataSaveProgress((prevValues) => ({
          ...prevValues,
          open: true,
          addevent: true,
          subscribEvent: false,
        }));
      }
      (async () => {
        setFrequency(pricingType[0])
        setSubscriptionPlan([])
        await getAvailableUserAccess()
        await getSubscriptionPlan();
      })();
    }
  }, [userReduxState.businessType]);

  React.useEffect(() => {
    dispatch(clearLoadingData());
    setFrequency(pricingType[0])
  }, []);

  React.useEffect(() => {
    if (dataSaveProgress.addevent === true && dataSaveProgress.subscribEvent === false && subscriptionPlan.length > 0) {

      startEventAutomation()
      // setTimeout(() => {
      //   (async () => {
      //   })();
      // }, 1000);
    }
    // }, [subscriptionPlan, dataSaveProgress.addevent]);
  }, [subscriptionPlan]);

  return (renderLayout(location.state?.from === "list" ? "section" : (location.state?.from || location.state?.origin || ""),
    (<TwContainer className={""}>
      <div className="mx-auto max-w-7xl px-1 md:px-8">
        {userReduxState.businessType !== "event" ? (<div className="mx-auto max-w-7xl px-1 md:px-8">
          <>
            <fieldset aria-label="Payment frequency">
              <RadioGroup
                value={frequency}
                onChange={setFrequency}
                className={classNames("grid grid-cols-2 gap-x-1 rounded-full bg-white/5 p-1 text-center text-xs/5 font-semibold text-gray-900",
                  subscriptionPlan.length ? "" : "hidden"
                )}
              >
                {userReduxState.businessType !== "event" && pricingType.length > 0 && pricingType.map((option) => {

                  // if (option.value === "year" && (subscriptionPlan.filter((d) => d.isActive === true && d.billingType === "year")).length > 0) {
                  if (option.value === "year" && userReduxState.businessType === "event") {
                    return null
                  } else {
                    return (
                      <Radio
                        key={option.value}
                        value={option}
                        className="cursor-pointer rounded-full px-2.5 py-1 data-[checked]:bg-portland-orange data-[checked]:text-white"
                      >
                        {option.label}
                      </Radio>
                    )
                  }
                })}
              </RadioGroup>
            </fieldset>
          </>
          {/* <div className={`relative mx-auto mt-10 grid 1max-w-lg grid-cols-${subscriptionPlan.filter((d) => d.isActive === true && frequency.value && d.billingType == frequency.value).length > 1 ? "2" : "1"} gap-8 1lg:mx-0 1lg:-mb-14 1lg:max-w-none 1lg:grid-cols-3 md:grid-cols-1`}> */}
          {/* <div className={`isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-${subscriptionPlan.filter((d) => d.isActive === true && frequency.value && d.billingType === frequency.value).length}`}> */}
          {/* <div className={`isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-${subscriptionPlan.filter((d) => d.isActive === true && frequency.value && d.billingType === frequency.value).length}`}> */}
          {/* <div className={`isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none ${subscriptionPlan.filter((d) => d.isActive === true && frequency.value && d.billingType === frequency.value).length ? `lg:grid-cols-${subscriptionPlan.filter((d) => d.isActive === true && frequency.value && d.billingType === frequency.value).length}` : 'lg:grid-cols-1'}`}> */}
          <div className={classNames(
            `isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8`,
            userReduxState.businessType === "service" ? `lg:mx-0 lg:max-w-none lg:grid-cols-2` : 'lg:grid-cols-1'
          )}>
            {/* <div
            aria-hidden="true"
            className="hidden lg:absolute lg:inset-x-px lg:bottom-0 lg:top-4 lg:block lg:rounded-t-2xl lg:bg-gray-800/80 lg:ring-1 lg:ring-white/10"
          > */}
            {userReduxState.businessType !== "event" && subscriptionPlan && subscriptionPlan.filter((d) => d.isActive === true && frequency.value && d.billingType == frequency.value).map((d, i) => {
              d.isCurrentPurchase = true;
              let primarySubscription = availableUserAccess?.subscriptionDetails?.primarySubscription
              if (primarySubscription?.allowbusinessAccess && primarySubscription.allowbusinessAccess === true
                && d?.stripeSubscriptionDetails?.stripeSubscriptionPriceId
                && primarySubscription.stripeSubscriptionPlanId
              ) {
                d.isCurrentPurchase = true
                if (d?.stripeSubscriptionDetails?.stripeSubscriptionPriceId == primarySubscription.stripeSubscriptionPlanId) {
                  d.isCurrentPurchase = false
                }
              }
              return (
                <div
                  key={i}
                  className={
                    `${d.isCurrentPurchase
                      ? 'z-10 bg-white shadow-xl ring-1 ring-gray-900/10'
                      : 'bg-gray-800/80 ring-1 ring-white/10 [lg:bg-transparent] lg:pb-14 lg:ring-0'} ${subscriptionPlan.filter((d) => d.isActive === true && frequency.value && d.billingType == frequency.value).length > 1 ? "" : "max-w-lg"} relative rounded-2xl`
                  }
                >
                  <div className="p-8 lg:pt-12 xl:p-10 xl:pt-14">
                    <h2
                      id={i}
                      className={`${d.isCurrentPurchase ? 'text-gray-900' : 'text-white'} text-sm/6 font-semibold`}
                    >
                      {d.title}
                    </h2>
                    <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between lg:flex-col lg:items-stretch">
                      <div className="mt-2 flex items-center gap-x-4">
                        <p
                          className={`${d.isCurrentPurchase ? 'text-gray-900' : 'text-white'} text-4xl font-semibold tracking-tight`}
                        >
                          {parseFloat(d.price).toFixed(2)}
                        </p>
                        <div className="text-sm">
                          <p className={d.isCurrentPurchase ? 'text-gray-900' : 'text-white'}>EUR</p>
                          <p
                            className={d.isCurrentPurchase ? 'text-gray-500' : 'text-gray-400'}
                          >{`Billed ${d.billingType}`}</p>
                        </div>
                      </div>
                      {d.billingType == "year" && (<div className="text-sm">
                        <p
                          className={d.isCurrentPurchase ? 'text-gray-500' : 'text-gray-400'}
                        >
                          {`You Saved ${parseFloat(((subscriptionPlan.filter((d) => d.isActive === true && d.billingType === "month")[0]?.price ?? 0) * 12) - d.price).toFixed(2)}`}
                        </p>
                      </div>)}
                      <button
                        // href={tier.href}
                        aria-describedby={i}
                        className={`${d.isCurrentPurchase
                          ? 'bg-portland-orange shadow-sm hover:bg-light-portland-orange focus-visible:outline-portland-orange' : 'bg-white/10 hover:bg-white/20 focus-visible:outline-white'} 
                        rounded-md px-3 py-2 text-center text-sm/6 font-semibold text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2`}
                        onClick={() => {
                          setSubscriptionSubmited(d)
                          let primarySubscription = availableUserAccess?.subscriptionDetails?.primarySubscription
                          if (primarySubscription?.allowbusinessAccess && primarySubscription.allowbusinessAccess === true
                            && d?.stripeSubscriptionDetails?.stripeSubscriptionPriceId
                            && primarySubscription.stripeSubscriptionPlanId
                          ) {
                            if (d?.stripeSubscriptionDetails?.stripeSubscriptionPriceId == primarySubscription.stripeSubscriptionPlanId) {
                              // not allowed
                            } else {
                              updateUserSubscription(d._id, d);
                            }
                          } else {
                            createUserSubscriptionCheckoutSessions(d._id, d);
                          }
                        }}
                        // disable={(loadingReduxState.actionLoading !== undefined && loadingReduxState.actionLoading === true) || d.isCurrentPurchase.toString()}
                        disabled={((loadingReduxState.actionLoading !== undefined && loadingReduxState.actionLoading === true) || (d.isCurrentPurchase === false)) ? true : false}
                      >
                        {subscriptionText(d, i)}
                      </button>
                    </div>
                    <div className="mt-8 flow-root sm:mt-10">
                      <ul
                        role="list"
                        className={`${d.isCurrentPurchase
                          ? 'divide-gray-900/5 border-gray-900/5 text-gray-600'
                          : 'divide-white/5 border-white/5 text-white'} 
                          -my-2 divide-y border-t text-sm/6 lg:border-t-0`}
                      >
                        {d.subscriptionDetail.map((mainFeature) => (
                          <li key={mainFeature} className="flex gap-x-3 py-2">
                            <CheckIcon
                              aria-hidden="true"
                              className={`${d.isCurrentPurchase ? 'text-portland-orange' : 'text-gray-500'} h-6 w-5 flex-none`}
                            />
                            {/* {mainFeature} */}
                            <p className="flex-1" dangerouslySetInnerHTML={{ __html: mainFeature }}></p>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>) : dataSaveProgress.open ? (
          <div
            className={"sm:mr-4 flex justify-center w-full"}
          >
            <div className="flex flex-col gap-8 justify-center items-center h-96 w-full max-w-2xl">
              <BZLogo className={""} />
              <div className="flex justify-between items-center w-full">
                <div className="flex-1 pl-2 text-gray-500">
                  Creating Business Account
                </div>
                <div className="flex-none">
                  <img
                    className={""}
                    src={(dataSaveProgress.createAccount) ? progressdone : loader}
                    alt={""}
                  />
                </div>
              </div>
              <div className="flex justify-center items-center w-full">
                <div className="flex-1 pl-2 text-gray-500">
                  Setting Up Your Account
                </div>
                <div className="flex-none">
                  <img
                    className={""}
                    src={(dataSaveProgress.createSettingUp) ? progressdone : loader}
                    alt={""}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (<></>)}
      </div>
      {/* <TwDialog
        dialogTitle={""}
        dialogOpen={dataSaveProgress.open}
        open={dataSaveProgress.open}
        showXBtn={false}
        isFullContent={true}
        isAllowBackdropClick={false}
        onClose={() => {

          setDataSaveProgress((prevValues) => ({
            ...prevValues,
            open: false,
          }));
        }}
      >
        <div
          className={"sm:mr-4"}
        >
          <div className="flex flex-col justify-center items-center">
            <div className="flex justify-between items-center w-full py-3">
              <div className="flex-1 pl-2 text-gray-500">
                Creating Business Account
              </div>
              <div className="flex-none">
                <img
                  className={""}
                  src={(dataSaveProgress.createAccount) ? progressdone : loader}
                  alt={""}
                />
              </div>
            </div>
            <div className="flex justify-center items-center w-full py-3">
              <div className="flex-1 pl-2 text-gray-500">
                Setting Up Your Account
              </div>
              <div className="flex-none">
                <img
                  className={""}
                  src={(dataSaveProgress.createSettingUp) ? progressdone : loader}
                  alt={""}
                />
              </div>
            </div>
          </div>
        </div>
      </TwDialog> */}
    </TwContainer >
    ))
  );
}
